// External Dependencies:
import React from 'react'

class Select extends React.Component {
	handleChange = ( e ) => {
		this.props.onChange( this.props.id, e.target.value )
	}

	render() {
		const { id, label, value, options } = this.props
		let optionsMarkup = ''

		optionsMarkup = options.map( ( e ) => {
			let key = e.value ? e.value : Math.random()

			return (
				<option key={ key } value={ e.value }>{ e.name }</option>
			)
		})

		return (
			<div className="form-item form-select">
				<i className="icon-chevron-down" aria-hidden="true"></i>

				<label htmlFor={ id } dangerouslySetInnerHTML={ { __html: label } } />

				<select name={ id } onChange={ this.handleChange } value={ value }>
					{ optionsMarkup }
				</select>
			</div>
		)
	}
}

export default Select



// WEBPACK FOOTER //
// ./components/form/select.jsx